import React from "react";
import { Container, Box, Typography } from "@mui/material";
import Footer from "../components/Footer";

const TermsAndConditions: React.FC = () => {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Container maxWidth="md" sx={{ py: 8, flex: 1 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: December 21, 2025
        </Typography>

        <Box
          sx={{
            "& h2": { fontSize: "1.5rem", fontWeight: 600, mt: 4, mb: 2 },
            "& p": { lineHeight: 1.8, mb: 2 },
          }}
        >
          <Typography variant="h5" component="h2">
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1">
            By accessing and using shashi-sharma.com.np, you accept and agree to
            be bound by the terms and provision of this agreement.
          </Typography>

          <Typography variant="h5" component="h2">
            2. Use License
          </Typography>
          <Typography variant="body1">
            Permission is granted to temporarily download one copy of the
            materials (information or software) on our website for personal,
            non-commercial transitory viewing only.
          </Typography>
          <Typography variant="body1">
            This license shall automatically terminate if you violate any of
            these restrictions.
          </Typography>

          <Typography variant="h5" component="h2">
            3. Disclaimer
          </Typography>
          <Typography variant="body1">
            The materials on our website are provided on an as is basis. We make
            no warranties, expressed or implied, and hereby disclaim and negate
            all other warranties including, without limitation, implied
            warranties or conditions of merchantability, fitness for a
            particular purpose, or non-infringement of intellectual property or
            other violation of rights.
          </Typography>

          <Typography variant="h5" component="h2">
            4. Limitations
          </Typography>
          <Typography variant="body1">
            In no event shall Shashi Sharma or its suppliers be liable for any
            damages including, without limitation, damages for loss of data or
            profit, or due to business interruption arising out of the use or
            inability to use the materials on our website.
          </Typography>

          <Typography variant="h5" component="h2">
            5. Accuracy of Materials
          </Typography>
          <Typography variant="body1">
            The materials appearing on our website could include technical,
            typographical, or photographic errors. We do not warrant that any of
            the materials on our website are accurate, complete, or current.
          </Typography>

          <Typography variant="h5" component="h2">
            6. Third-Party Content and Links
          </Typography>
          <Typography variant="body1">
            Our website may display content from third-party sources, including:
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <li>
              News articles and stories from Hacker News and other websites
            </li>
            <li>Embedded content via iframes from external websites</li>
            <li>Links to external websites</li>
          </Box>
          <Typography variant="body1">
            We do not own, control, or endorse this third-party content. We are
            not responsible for the accuracy, legality, or any other aspect of
            such content. External websites may have their own terms of service
            and privacy policies. Some websites may prevent embedding and
            display error messages - this is their right and outside our
            control.
          </Typography>

          <Typography variant="h5" component="h2">
            7. Modifications
          </Typography>
          <Typography variant="body1">
            We may revise these terms of service at any time without notice. By
            using this website, you are agreeing to be bound by the then current
            version of these terms of service.
          </Typography>

          <Typography variant="h5" component="h2">
            8. Governing Law
          </Typography>
          <Typography variant="body1">
            These terms and conditions are governed by and construed in
            accordance with applicable laws.
          </Typography>

          <Typography variant="h5" component="h2">
            Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions about these Terms and Conditions, please
            contact us at sharmashashi940@gmail.com
          </Typography>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default TermsAndConditions;
